import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../../api/apiSlice';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import ExternalScreen from '../../../components/fragments/ExternalScreen';
import ImageUpload from '../../../components/ui/ImageUpload';
import Form from '../../../components/utilities/Form';
import errorSnackbar from '../../../utils/errorSnackbar';

const validator = Yup.object().shape({
    post: Yup.string().min(2).max(500).required().label('Post Content'),
    images: Yup.mixed().label('Profile Image'),
});

export default function ScreenCreatePost() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [createPost, { isLoading }] = useCreateListDataMutation();

    return (
        <ExternalScreen title="Create Post">
            <Grid item xs={12}>
                <Form
                    validationSchema={validator}
                    initialValues={{ post: '', images: [] }}
                    onSubmit={async ({ post, images }) => {
                        const formData = new FormData();
                        formData.append('post', post);
                        images.forEach((img) => {
                            formData.append('images[]', img);
                        });

                        const { error, data } = await createPost({
                            list: `/op/posts`,
                            body: formData,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Successfully created post');
                            navigate(-1);
                        }
                    }}
                >
                    <ImageUpload name="images" limit={3} />
                    <FormikInput name="post" label="Post" />
                    <div className="d-flex justify-content-end w-100">
                        <FormikButton loading={isLoading} variant="contained">
                            Create
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </ExternalScreen>
    );
}
